// Copyright (c) 2023, Alix Mougenot (Au pied des Arbres), alix.mougenot@gmail.com
// See license file.
import { createRouter, createWebHistory } from "vue-router";
import Dossiers from "../views/Dossiers.vue";
import Plaignants from "../views/Plaignants.vue";
import Centres from "../views/Centres.vue";
import Dentistes from "../views/Dentistes.vue";
import Templates from "@/views/Templates.vue";
import Test from "@/views/Test.vue";

export const filesPathName = "dossiers";
export const complaintsPathName = "plaintes";
export const infoPathName = "informations";
export const signalPathName = "signalements";
export const differentPathName = "differents";
export const dentistsPathName = "dentistes";
export const healthCentersPathName = "centres";
export const actorsPathName = "plaignants";
export const templatesPatientPathName = "templates/patient";
export const templatesPraticienPathName = "templates/praticien";
export const templatesAdministratifPathName = "templates/administratif";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/dossier/p",
      name: complaintsPathName,
      component: Dossiers,
    },
    {
      path: "/dossier/i",
      name: infoPathName,
      component: Dossiers,
    },
    {
      path: "/dossier/s",
      name: signalPathName,
      component: Dossiers,
    },
    {
      path: "/dossier/d",
      name: differentPathName,
      component: Dossiers,
    },
    {
      path: "/dossier/:id?",
      name: filesPathName,
      component: Dossiers,
    },
    {
      path: "/plaignant/:id?",
      name: actorsPathName,
      component: Plaignants,
    },
    {
      path: "/centre/:id?",
      name: healthCentersPathName,
      component: Centres,
    },
    {
      path: "/dentiste/:id?",
      name: dentistsPathName,
      component: Dentistes,
    },
    {
      path: "/templates/patient",
      name: templatesPatientPathName,
      component: Templates,
      props: { category: "Patient" },
    },
    {
      path: "/templates/praticien",
      name: templatesPraticienPathName,
      component: Templates,
      props: { category: "Praticiens & Centres" },
    },
    {
      path: "/templates/administratif",
      name: templatesAdministratifPathName,
      component: Templates,
      props: { category: "Administratif" },
    },
    { path: "/test", component: Test },
  ],
});

export default router;
